import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { GridModule } from '@progress/kendo-angular-grid';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { DeviceViewAdminComponent } from './device-view-admin/device-view-admin.component';
import { DeviceViewClientComponent } from './device-view-client/device-view-client.component';
import { SharedModule } from "../shared/shared.module";
import { DeviceDetailComponent } from './device-detail/device-detail.component';
import { deviceCategoriesReducers } from '../stores/global/device-categories/reducers';
import { DeviceCategoriesEffets } from '../stores/global/device-categories/effects';
import { DeviceManufacturersEffets } from '../stores/global/device-manufacturers/device-manufacturers-effects';
import { deviceManufacturersReducers } from '../stores/global/device-manufacturers/device-manufacturers-reducers';
import { deviceReducers } from '../stores/global/devices/device-reducers';
import { DeviceEffets } from '../stores/global/devices/device-effects';
import { DeviceDetailWearingPartsComponent } from './device-detail/device-detail-wearing-parts/device-detail-wearing-parts.component';
import { DeviceDetailServicesComponent } from './device-detail/device-detail-services/device-detail-services.component';
import { DeviceDetailNotesComponent } from './device-detail/device-detail-notes/device-detail-notes.component';
import { DeviceDetailAttachmentsComponent } from './device-detail/device-detail-attachments/device-detail-attachments.component';
import { IndicatorsModule } from "@progress/kendo-angular-indicators";


@NgModule({
  declarations: [
    DeviceViewAdminComponent,
    DeviceViewClientComponent,
    DeviceDetailComponent,
    DeviceDetailWearingPartsComponent,
    DeviceDetailServicesComponent,
    DeviceDetailNotesComponent,
    DeviceDetailAttachmentsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    GridModule,
    UploadsModule,
    DateInputsModule,
    IndicatorsModule,
    SharedModule,
    StoreModule.forFeature('deviceCategories', deviceCategoriesReducers),
    StoreModule.forFeature('deviceManufacturers', deviceManufacturersReducers),
    StoreModule.forFeature('devices', deviceReducers),
    EffectsModule.forFeature([DeviceCategoriesEffets]),
    EffectsModule.forFeature([DeviceManufacturersEffets]),
    EffectsModule.forFeature([DeviceEffets])
]
})
export class DevicesModule { }
